import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/ice-cream-factory/index.vue')
const Rank = () => import('../activity/ice-cream-factory/Rank.vue')
const Record = () => import('../activity/ice-cream-factory/Record.vue')
const Maker = () => import('../activity/ice-cream-factory/Maker.vue')

export const index: RouteConfig = {
  path: '/ice-cream-factory',
  name: 'iceCreamFactory',
  component: Index,
  meta: {
    title: '冰激凌工厂',
  },
}

export const record: RouteConfig = {
  path: '/ice-cream-factory-record',
  name: 'iceCreamFactoryRecord',
  component: Record,
  meta: {
    title: '冰激凌工厂',
  },
}

export const maker: RouteConfig = {
  path: '/ice-cream-factory-maker',
  name: 'iceCreamFactoryMaker',
  component: Maker,
  meta: {
    title: '冰激凌工厂',
  },
}

export const rank: RouteConfig = {
  path: '/ice-cream-factory-rank',
  name: 'iceCreamFactoryRank',
  component: Rank,
  meta: {
    title: '冰激凌工厂',
  },
}

export default [index, rank, record, maker]
